import {
  CATALOG_LIMIT,
  CATALOG_SCOPE,
  catalogSuccess,
  catalogUnavailable,
  type CapabilityDefinitionCatalogReadResultV1,
} from '../../consumer/catalog-contract';
import { parseCapabilityDefinitionWire } from './capability-definition-wire';
export class CatalogWireError extends Error {
  constructor() {
    super('Invalid capability definition catalog wire');
    this.name = 'CatalogWireError';
  }
}
export function parseCapabilityDefinitionCatalogWire(
  value: unknown,
): CapabilityDefinitionCatalogReadResultV1 {
  try {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
      throw new CatalogWireError();
    const keys = ['status', 'scope', 'coverage', 'limit', 'items'];
    if (
      Reflect.ownKeys(value).length !== keys.length ||
      keys.some((key) => !Object.hasOwn(value, key))
    )
      throw new CatalogWireError();
    if (
      !('status' in value) ||
      !('scope' in value) ||
      !('coverage' in value) ||
      !('limit' in value) ||
      !('items' in value) ||
      value.scope !== CATALOG_SCOPE ||
      value.limit !== CATALOG_LIMIT
    )
      throw new CatalogWireError();
    if (value.status === 'SOURCE_UNAVAILABLE') {
      if (value.items !== null || value.coverage !== 'UNKNOWN') throw new CatalogWireError();
      return catalogUnavailable();
    }
    if (
      value.status !== 'SUCCESS' ||
      !Array.isArray(value.items) ||
      (value.coverage !== 'NOT_TRUNCATED' && value.coverage !== 'TRUNCATED_AT_LIMIT')
    )
      throw new CatalogWireError();
    const items = value.items.map((snapshot: unknown) => {
      if (
        typeof snapshot !== 'object' ||
        snapshot === null ||
        !('capabilityId' in snapshot) ||
        typeof snapshot.capabilityId !== 'string'
      )
        throw new CatalogWireError();
      const parsed = parseCapabilityDefinitionWire(
        { status: 'AVAILABLE', capabilityId: snapshot.capabilityId, snapshot },
        snapshot.capabilityId,
      );
      if (parsed.status !== 'AVAILABLE') throw new CatalogWireError();
      return parsed.snapshot;
    });
    return catalogSuccess(items, value.coverage);
  } catch {
    throw new CatalogWireError();
  }
}
